import { useCallback } from 'react';
import { useAuth } from '@/auth/AuthContext';
import {
  themeToApiPreference,
  useThemeStore,
  type Theme,
} from '@/stores/theme-store';

/**
 * Theme store + Firebase preference sync when the user is signed in.
 * Applies theme locally immediately; persists via PUT /preference in the background.
 */
export function useThemePreference() {
  const { user, updatePreference } = useAuth();
  const theme = useThemeStore((s) => s.theme);
  const setThemeLocal = useThemeStore((s) => s.setTheme);
  const getEffectiveTheme = useThemeStore((s) => s.getEffectiveTheme);
  const primaryColor = useThemeStore((s) => s.primaryColor);
  const setPrimaryColor = useThemeStore((s) => s.setPrimaryColor);

  const setTheme = useCallback(
    (next: Theme) => {
      setThemeLocal(next);
      if (user) {
        void updatePreference({ theme: themeToApiPreference(next) }).catch((err) => {
          console.error('Failed to sync theme preference:', err);
        });
      }
    },
    [user, setThemeLocal, updatePreference]
  );

  return { theme, setTheme, getEffectiveTheme, primaryColor, setPrimaryColor };
}
